<div class="ltms-outbox-single-request-container">
    <!-- Multi request tab -->

    <!-- Checkbox: Exclude from statistics -->
    <div class="d-flex flex-column input-container">
        <label class="d-flex align-items-center gap-2 mb-2">
            <input type="checkbox" [(ngModel)]="isExcludedFromStatistics" style="display: none;"/>
            <div class="checkbox-container">
                <img [src]="isExcludedFromStatistics ? 'assets/images/checkbox-marked.svg' : 'assets/images/checkbox-blank-outline.svg'" />
                <!-- <img *ngIf="!isExcludedFromStatistics" src="assets/images/checkbox-blank-outline.svg" />
                <img *ngIf="isExcludedFromStatistics" src="assets/images/checkbox-marked.svg" /> -->
            </div>
            <span class="d-flex align-items-center">Exclude from statistics</span>
        </label>
        <span class="label-head-text">
            Enabling this will exclude the responses from the Summary count.
        </span>
    </div>

    <div class="d-flex flex-column input-container">
        <label class="label-up-text text-weight"> Request Channels </label>
        <div class="d-flex">
            <label class="d-flex align-items-center gap-2" (click)="toggleChannel('SMS')">
                <!-- <input type="checkbox" [checked]="selectedRequestChannels.includes('SMS')"
                    (change)="toggleChannel('SMS')"/> -->
                <div class="checkbox-container">
                    <img [src]="selectedRequestChannels.includes('SMS') ? 'assets/images/checkbox-marked.svg' : 'assets/images/checkbox-blank-outline.svg'" />
                    <!-- <img *ngIf="!selectedRequestChannels.includes('SMS')" [src]="selectedRequestChannels.includes('SMS')?'assets/images/checkbox-blank-outline.svg':'assets/images/checkbox-marked.svg'" /> -->
                    <!-- <img *ngIf="selectedRequestChannels.includes('SMS')" src="assets/images/checkbox-marked.svg" /> -->
                </div>
                <span class="d-flex align-items-center">SMS</span>
            </label>
            <label class="d-flex align-items-center gap-2 emait-text" (click)="toggleChannel('Email')">
                <!-- <input type="checkbox" [checked]="selectedRequestChannels.includes('Email')"
                    (change)="toggleChannel('Email')" /> -->
                <div class="checkbox-container">
                    <img [src]="selectedRequestChannels.includes('Email') ? 'assets/images/checkbox-marked.svg' : 'assets/images/checkbox-blank-outline.svg'" />
                    <!-- <img *ngIf="!selectedRequestChannels.includes('Email')" src="assets/images/checkbox-blank-outline.svg" />
                    <img *ngIf="selectedRequestChannels.includes('Email')" src="assets/images/checkbox-marked.svg" /> -->
                </div>
                <span class="d-flex align-items-center">Email</span>
            </label>
            <label class="d-flex align-items-center gap-2 WA-text" (click)="toggleChannel('WA')">
                <!-- <input type="checkbox" [checked]="selectedRequestChannels.includes('WA')"
                    (change)="toggleChannel('WA')" /> -->
                <div class="checkbox-container">
                    <img [src]="selectedRequestChannels.includes('WA') ? 'assets/images/checkbox-marked.svg' : 'assets/images/checkbox-blank-outline.svg'" />
                    <!-- <img *ngIf="!selectedRequestChannels.includes('WA')" src="assets/images/checkbox-blank-outline.svg" />
                    <img *ngIf="selectedRequestChannels.includes('WA')" src="assets/images/checkbox-marked.svg" /> -->
                </div>
                <span class="d-flex align-items-center">WhatsApp</span>
            </label>
        </div>
    </div>

    <!-- Name Input -->
    <div class="d-flex flex-column input-container">
        <label class="label-up-text text-weight"> Name </label>
        <input type="text" #name placeholder="Enter customer's name" required (keyup)="validateForm()" />
        <div class="error-message" *ngIf="nameError">{{ nameError }}</div>
    </div>

    <!-- Country Code & Mobile Number -->
    <div class="number-container d-flex justify-content-between gap-3 mb-2 number-card">
        <!-- Mobile Number for SMS -->
        <!-- <div class="sms-num-container d-flex flex-column" *ngIf="selectedRequestChannels.includes('SMS')">
            <label class="label-up-text text-weight">Mobile Number for SMS:</label>
            <div class="d-flex align-items-center">
                <select class="dial-code2" (change)="setSelectedCountry($event)">
                    <option *ngFor="let country of countries" [value]="country.code"
                        [selected]="selectedCountry.code === country.code">
                        {{ country.dial_code }}
                    </option>
                </select>
              <span class="dial-code">{{ selectedCountry.dial_code }}</span> 
                <input class="sms-mobile" type="text" #mobileSMS placeholder="Enter mobile number"
                    [pattern]="selectedCountryPattern" required (keyup)="validateForm()" />
            </div>
        </div> -->
        <div class="sms-num-container d-flex flex-column" *ngIf="selectedRequestChannels.includes('SMS')">
            <label class="label-up-text text-weight">Mobile Number for SMS</label>
            <div class="d-flex align-items-center dial-code-container" [ngClass]="{'invalid-input': mobileNumberError}">
                <select class="dial-code2" (change)="setSelectedCountry($event,'SMS')">
                    <option *ngFor="let country of countries" [value]="country.code"
                        [selected]="selectedCountrySMS.code === country.code">
                        {{ country.dial_code }}
                    </option>
                </select>
                <img class="dropdown-arrow country-code-dd" [ngClass]="{'rotate-180': isDropdownOpen('sms')}"
                 src="assets/images/menu-down-dark.svg" alt="Dropdown Icon" />
                 <input class="sms-mobile" type="text" #mobileSMS placeholder="Enter mobile number"
                 [pattern]="selectedCountrySMS?.pattern || '^\\d{10}$'" required (keyup)="validateForm()" maxlength="10" />                       
            </div>
            <span *ngIf="mobileNumberError" class="error-message">{{ mobileNumberError }}</span>
            <!-- Show error message dynamically -->
            <!-- <p *ngIf="mobileNumberError" class="error-message">{{ mobileNumberError }}</p> -->
        </div>

        <!-- Mobile Number for WhatsApp -->
        <div class="WA-num-container d-flex flex-column wa-container" *ngIf="selectedRequestChannels.includes('WA')">
            <label class="label-up-text text-weight" [ngClass]="{'disabled-text': formData.isSameNumberWA}">Mobile Number for WhatsApp</label>
            <div class="d-flex align-items-center dial-code-container" [ngClass]="{'disabled': formData.isSameNumberWA, 'invalid-input': whatsappNumberError}">
                <select class="dial-code2 dial-code2-bg" (change)="setSelectedCountry($event, 'WA')">
                    <option *ngFor="let country of countries" [value]="country.code"
                        [selected]="selectedCountryWA.code === country.code">
                        {{ country.dial_code }}
                    </option>
                </select>
                <img class="dropdown-arrow country-code-dd" [ngClass]="{'rotate-180': isDropdownOpen('wa')}"
                    src="assets/images/menu-down-dark.svg" alt="Dropdown Icon" />
                <!-- <span class="dial-code">{{ selectedCountry.dial_code }}</span> -->
                <input class="wa-mobile" type="text" #mobileWA placeholder="Enter WhatsApp number" (keyup)="validateForm()"
                [pattern]="selectedCountryWA?.pattern || '^\\d{10}$'" maxlength="10"/>
            </div>
            <span *ngIf="whatsappNumberError" class="error-message">{{ whatsappNumberError }}</span>
        </div>
    </div>

    <div class="d-flex flex-column input-container wa-checkbox-input"
        *ngIf="selectedRequestChannels.includes('SMS') && selectedRequestChannels.includes('WA')">
        <label (click)="toggleWASameAsPhone()">
            <!-- <input type="checkbox" id="" #sameNumberWA (change)="syncNumbers()" style="display: none;"/> -->
            <div class="checkbox-container mb-1">
                <img [src]="formData.isSameNumberWA ? 'assets/images/checkbox-marked.svg' : 'assets/images/checkbox-blank-outline.svg'" />
                <!-- <img *ngIf="!formData.isSameNumberWA" src="assets/images/checkbox-blank-outline.svg" />
                <img *ngIf="formData.isSameNumberWA" src="assets/images/checkbox-marked.svg" /> -->
            </div>
            <span class="label-below-text ms-1" for="sameNumberWA"> Same number for WhatsApp</span>
        </label>
    </div>

    <!-- Email Input -->
    <div class="d-flex flex-column input-container" *ngIf="selectedRequestChannels.includes('Email')">
        <label class="label-up-text text-weight">Email ID</label>
        <input type="email" [ngClass]="{'invalid-input': emailError}" #email placeholder="Enter customer's email" (keyup)="validateForm()" />
        <span *ngIf="emailError" class="error-message">{{ emailError }}</span>
    </div>
    <div *ngIf="tagLength">
        <div class="custom-tags-container">
            <div class="custom-tag-card">
                <div class="tag-header">
                    <label class="custom-head">Transaction Data</label>

                    <!-- Condition: At index 0, show "Clear Selection" and disable it initially -->
                    <div class="clear-selection-text"
                        [ngClass]="{'enabled-text': isClearSelectionActive('transactionData'), 'disabled-text': !isClearSelectionActive('transactionData')}"
                        (click)=" isClearSelectionActive('transactionData') ? clearSelection() : null">
                        Clear Selection
                    </div>

                    <!-- Show Delete Icon for other indexes -->
                    
                </div>
                <div *ngFor="let tag of transactionDatas; let i = index" class="mb-2">
                    
                    <div class="tag-header">
                        <label></label>
                        <button *ngIf="i !== 0" class="remove-tag-btn" (click)="removeTransactionData(i)">
                            <img class="trash-icon" src="assets/images/trash-can-outline.svg">
                        </button>
                    </div>
                    <!-- Dropdown -->
                    <div class="dropdown-container" (click)="toggleDropdown(i)">
                        <input type="text" class="dropdown-input transaction-input" [value]="transactionDatas[i].tagName || placeholder"
                            readonly placeholder="Select from the list" />
                        <img class="dropdown-arrow" src="assets/images/menu-down-dark.svg" alt="Dropdown Icon" />
                    </div>

                    <div class="dropdown-content" *ngIf="showDropdown[i]">
                        <div class="dropdown-item" *ngFor="let option of touchpointOptions"
                            (click)="selectOption(option, i)">
                            {{ option }}
                        </div>
                    </div>
                    <br />

                    <!-- Input Field -->
                    <div class="tag-fields">
                        <input type="text" [(ngModel)]="transactionDatas[i].tagValue"
                            placeholder="Tag Value" />
                    </div>
                    
                </div>
                <button class="add-tag-btn"
                        (click)="addTransactionData()" [disabled]="!isAddTransactionElabled()">
                        Add
                    </button>
            </div>
        </div>
    </div>
    <br />
    <div class="custom-tags-container">
        <div class="custom-tag-card">
            <div class="tag-header">
                <h6 class="custom-head">Custom Tags</h6>
                <div class="clear-selection-text"  [ngClass]="{'enabled-text': isClearSelectionActive('customTag'), 'disabled-text': !isClearSelectionActive('customTag')}"
                (click)="isClearSelectionActive('customTag') ? clearCustomTags() : null">
                    Clear Selection
                </div>
            </div>
            
            <label class="label-below-text mb-2">{{customTagMsg}}</label>
            <div *ngFor="let tag of customTags; let i = index" class="mb-3">
                <div class="tag-header">
                    <label></label>
                    <button class="remove-tag-btn remove-top" (click)="removeCustomTag(i)" *ngIf="i !== 0">
                        <img class="trash-icon" src="assets/images/trash-can-outline.svg"></button>
                </div>
                <div class="tag-fields">
                    <input type="text" [(ngModel)]="customTags[i].tagName" (keyup)="restrictNonEnglish(i)" placeholder="Tag name" />
                </div>
                <br />
                <div class="tag-fields">
                    <input type="text" [(ngModel)]="customTags[i].tagValue" (keyup)="restrictNonEnglish(i)" placeholder="Tag value" />
                </div>

            </div>
            <span *ngIf="(isRestrictedSpecialCharacter || !isTagDataEnglish)" class="error-message">Please enter only valid characters</span>
            <button class="add-tag-btn" (click)="addCustomTag()" [disabled]="!isAddCustomTagElabled()">Add</button>
        </div>
    </div>

    <!-- Submit Button -->
    <div class="action-container">
        <button class="action-cencel-btn" (click)="cancelRequest()">Cancel</button>
        <button class="action-request-btn" (click)="submitRequest()"
            [ngClass]="{'enabled-btn': isFormValid, 'disabled-btn': !isFormValid}" [disabled]="!isFormValid">
            Trigger request
        </button>
    </div>

</div>